import React, { useState, useEffect } from 'react';
import { Button, Modal, TextField, Box, Typography, Checkbox } from '@mui/material';
import { EntityFormdata } from '../../../interfaces/Entity.interface';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import { useRecoilValue } from 'recoil';
import {
  CampaignListActions,
  FlowBuilderActions,
  ManagementActions,
} from '../../../Services/_actions';
import { userInformationAtom } from '../../../Services/_states/auth.js';

interface ModalFormProps {
  open: boolean;
  onClose: () => void;
  title: string;
  selectedBusiness: EntityFormdata | any;
  handleSubmit: (data: EntityFormdata) => void;
}

const FormTypes = [
  { label: 'Contact', value: 'contact_form',business_types:null},
  { label: 'Student', value: 'student_form',businenssTypes:[1],businenssSubTypes:[1] },
  { label: 'Teacher', value: 'teacher_form',businenssTypes:[1],businenssSubTypes:[1] },
   { label: 'Syllabus', value: 'syllabus_form',businenssTypes:[1],businenssSubTypes:[1] },
  { label: 'Exam Calendar', value: 'exam_calendar_form' ,businenssTypes:[1],businenssSubTypes:[1]},
  { label: 'Teacher Master', value: 'teacher_master_form' ,businenssTypes:[1],businenssSubTypes:[1]},
  { label: 'Time Table', value: 'time_table_form' ,businenssTypes:[1],businenssSubTypes:[1]},
  { label: 'Holidays', value: 'holidays_form',businenssTypes:[1],businenssSubTypes:[1] },
  { label: 'School Marks', value: 'school_marks_form',businenssTypes:[1],businenssSubTypes:[1] },
   { label: 'Question Bank', value: 'question_bank_form' ,businenssTypes:[1],businenssSubTypes:[1]},
  { label: 'Others', value: null },
];

const BusinessModal: React.FC<ModalFormProps> = ({
  title,
  open,
  onClose,
  selectedBusiness,
  handleSubmit,
}) => {
  const [isloading, setIsLoading] = useState(false);
  const loggedInUser = useRecoilValue(userInformationAtom);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [campaignList, setCampaignList] = useState<{ pages: number; list: any[] }>({
    pages: 0,
    list: [],
  });
  const [errors, setErrors] = useState({
    nameField: '',
    content: '',
    entityId: '',
    headers: '',
    isUnicode: '',
    organisation: '',
    campaign_id: '',
  });

  const actions = ManagementActions();
  const action = FlowBuilderActions();
  const campaignActions = CampaignListActions();
  const [templateOptions, setTemplateOptions] = useState([]);
  const [templateLoading, setTemplateLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    organisation: null,
    campaign_id: '',
    campaign_name: '',
    // company_id: '',
    // organisation_name: '',
    is_template_form: false,
  });

  const [filterForCampaign, setFilterForCampaign] = useState({
    next_page: 1,
    search: '',
    to: 0,
    include_assigned_by: 0,
    fetch_all: 0,
    organisationId: '',
  });

  useEffect(() => {
    if (open && !loggedInUser?.is_superuser) {
      fetchTemplates();
    }
  }, [open, loggedInUser]);

  const fetchTemplates = async () => {
    setTemplateLoading(true);
    try {
      const res = await actions.fetchEntityTemplateForm();
      setTemplateOptions(res?.data?.items ?? []);
    } catch (error) {
      console.error('Failed to fetch template forms:', error);
      setTemplateOptions([]);
    } finally {
      setTemplateLoading(false);
    }
  };

  const handleFieldChange = (field: string, value: string | object) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleOrganisationChange = (selectedOrganisation: any) => {
    setFormData((prev) => ({
      ...prev,
      organisation: selectedOrganisation,
      // company_id: selectedOrganisation?.organisation_id || '',
      // organisation_name: selectedOrganisation?.name || '',
      campaign_id: '',
      campaign_name: '',
    }));
    setFilterForCampaign((prev) => ({
      ...prev,
      company_id: selectedOrganisation?.organisation_id || '',
      organisationId: selectedOrganisation?.organisation_id || '',
    }));
  };

  const handleCampaignChange = (selectedCampaign: any) => {
    setFormData((prev) => ({
      ...prev,
      campaign_id: selectedCampaign?.value || '',
      campaign_name: selectedCampaign?.label || '',
    }));
  };

  const onSubmit = () => {
    if (!validateForm()) return;

    const data = {
      ...formData,
      campaign_id: formData.campaign_id,
      campaign_name: formData.campaign_name,
      organisation: {
        organisation_id: formData.organisation?.organisation_id || '',
        name: formData.organisation?.name || '',
      },
    };

    handleSubmit(data);
    setFormData({
      name: '',
      description: '',
      organisation: null,
      campaign_id: '',
      campaign_name: '',
      // company_id: '',
      // organisation_name: '',
    });

    onClose();
  };

  const validateForm = () => {
    let errors: any = {};

    if (!formData.name.trim()) {
      errors.nameField = 'Title is required';
    }
    if (!formData.description.trim()) {
      errors.content = 'Description is required';
    }
    if (!formData.organisation) {
      errors.organisation = 'Organisation is required';
    }
    // if (!formData.campaign_id) {
    //   errors.campaign_id = 'Campaign is required';
    // }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (selectedBusiness) {
      setFormData({
        name: selectedBusiness?.name || '',
        description: selectedBusiness?.description || '',
        organisation: {
          organisation_id: selectedBusiness?.organisation?.company_id || '',
          name: selectedBusiness?.organisation?.name || '',
        },
        campaign_id: selectedBusiness?.campaign_id || '',
        campaign_name: selectedBusiness?.campaign_name || '',
        // company_id: selectedBusiness?.organisation?.organisation_id || '',
        // organisation_name: selectedBusiness?.organisation?.name || '',
        ...(selectedBusiness?.is_template_form && { is_template_form: selectedBusiness?.is_template_form ?? null }),
        ...(selectedBusiness?.cloned_entity_template_form && { cloned_entity_template_form: selectedBusiness?.cloned_entity_template_form ?? null }),
        ...(selectedBusiness?.template_form_type && { template_form_type: selectedBusiness?.template_form_type ?? null }),

      });
    } else {
      setFormData({
        name: '',
        description: '',
        organisation: null,
        campaign_id: '',
        campaign_name: '',
        // company_id: '',
        // organisation_name: '',
      });
    }
  }, [selectedBusiness, open]);

  const getCampaigns = async (filter: any) => {
    const orgId = filter.organisationId || formData.organisation?.organisation_id;
    if (!orgId) return;
    setIsLoading(true);
    try {
      const res = await action.getCampaignByOrganisation({ ...filter, organisationId: orgId });
      setCampaignList(res?.list ? res : { pages: 0, list: [] });
    } catch (e) {
      console.error('Error fetching campaigns:', e);
      setCampaignList({ pages: 0, list: [] });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // if (formData.organisation?.organisation_id) {
    const orgId = formData.organisation?.organisation_id;
    if (!open || !orgId) return;
    getCampaigns({ ...filterForCampaign, organisationId: orgId, next_page: 1 });
    // getCampaigns({ ...filterForCampaign, organisationId: formData.organisation?.organisation_id });
    // }
  }, [filterForCampaign, formData.organisation?.organisation_id, open]);

  // const handleSearchCampaign = (query: string) => {
  //   getCampaigns({ ...filterForCampaign, search: query, next_page: 1 });
  // };

  const loadMoreOptions = async () => {
    if (filterForCampaign.next_page <= campaignList.pages) {
      setIsLoading(true);
      let listData = [...campaignList.list];
      let newFilter = { ...filterForCampaign, next_page: filterForCampaign.next_page + 1 };

      try {
        let res = await campaignActions.getCampaignAssignment(newFilter);
        if (Array.isArray(res?.list)) {
          listData = [...listData, ...res.list];
        }
        setCampaignList({ ...res, list: listData });
        setFilterForCampaign((prev) => ({
          ...prev,
          next_page: prev.next_page + 1,
        }));
      } catch (error) {
        console.error('Error loading more campaigns:', error);
      }
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: '8px',
          p: 3,
          width: 400,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {selectedBusiness ? 'Edit' : 'Add'} Form
        </Typography>

        <OrganisationDropdown
          label={
            <Typography component="span">
              Organisation <span style={{ color: 'red' }}>*</span>
            </Typography>
          }
          value={formData.organisation}
          onChange={handleOrganisationChange}
          error={!!errors.organisation}
          errorMessage={errors.organisation}
          sx={{ mb: 1 }}
        />
        <SearchableDropdown
          label={
            <Typography component="span">
              Select Business Service
              {/* <span style={{ color: 'red' }}>*</span> */}
            </Typography>
          }
          options={
            campaignList.list.length > 0
              ? campaignList.list.map((campaign) => ({
                label: campaign.name || '',
                value: campaign.proposal_id || '',
              }))
              : [{ label: 'No Campaign', value: '' }]
          }
          value={
            formData.campaign_id
              ? { label: formData.campaign_name, value: formData.campaign_id }
              : null
          }
          // onSearch={handleSearchCampaign}
          onChange={handleCampaignChange}
          loading={isloading}
          fetchMoreOptions={
            campaignList.pages > filterForCampaign.next_page ? loadMoreOptions : undefined
          }
          error={!!errors.campaign_id}
          errorMessage={errors.campaign_id}
          sx={{ mb: 1 }}
        />
        {!loggedInUser?.is_superuser && (
          <SearchableDropdown
            label={
              <Typography component="span">
                Select From Template
              </Typography>
            }
            labelKey='name'
            valueKey='_id'
            options={
              templateOptions.length > 0
                ? templateOptions
                : [{ name: 'No templates available', value: null }]
            }
            value={templateOptions.find((option) => option._id === formData?.cloned_entity_template_form) ?? null}
            loading={templateLoading}
            onChange={(selected) =>
              setFormData((prev) => ({
                ...prev,
                cloned_entity_template_form: selected?._id || '',
                name: selected?.name || '',
                description: selected?.description || '',
              }))
            }
          />
        )}
        <TextField
          label={
            <Typography component="span">
              Title <span style={{ color: 'red' }}>*</span>
            </Typography>
          }
          size="small"
          variant="outlined"
          value={formData.name}
          onChange={(e) => handleFieldChange('name', e.target.value)}
          fullWidth
          margin="normal"
          error={!!errors.nameField}
          helperText={errors.nameField}
        />
        <TextField
          label={
            <Typography component="span">
              Description <span style={{ color: 'red' }}>*</span>
            </Typography>
          }
          variant="outlined"
          size="small"
          multiline
          sx={{ mb: 2 }}
          value={formData.description}
          onChange={(e) => handleFieldChange('description', e.target.value)}
          fullWidth
          margin="normal"
          error={!!errors.content}
          helperText={errors.content}
        />
        {loggedInUser?.is_superuser && (
          <>
            <Box display="flex" alignItems="center" mb={2}>
              <Checkbox
                checked={formData.is_template_form || false}
                onChange={(e) => handleFieldChange('is_template_form', e.target.checked)}
              />
              <Typography variant="body2">Save as Template Form</Typography>
            </Box>
            {formData.is_template_form && (
              <SearchableDropdown
                label={
                  <Typography component="span">
                    Select Form Type
                  </Typography>
                }
                value={
                  formData.template_form_type
                    ? { label: FormTypes.find(type => type.value === formData?.template_form_type)?.label || '', value: formData?.template_form_type }
                    : null
                }
                onChange={(selected) =>
                  handleFieldChange('template_form_type', selected?.value || '')
                }
                options={FormTypes}
              />
            )}
          </>
        )}
        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={onClose} size="small">
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={onSubmit}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BusinessModal;
